<script setup>
// [ByChat] Indicador de custo por mensagem na caixa HÍBRIDA. Em cada mensagem
// ENVIADA mostra um ícone de dinheiro ao lado da hora: VERDE = saiu pela conexão
// não-oficial (sem custo); AMARELO = saiu pela API oficial (com custo). A perna é
// gravada pelo initializer whatsapp_hybrid em content_attributes['hybrid_leg']:
// 'astracall' = grátis; 'official*' (direta/fallback/template) = custo. Só aparece
// quando a mensagem tem hybrid_leg (ou seja, só em caixa híbrida). Detalhe no hover.
import { computed } from 'vue';
import { useMessageContext } from './provider.js';
import { MESSAGE_TYPES } from './constants';

const { contentAttributes, messageType } = useMessageContext();

const leg = computed(
  () => contentAttributes.value?.hybridLeg ?? contentAttributes.value?.hybrid_leg
);
const show = computed(
  () => messageType.value === MESSAGE_TYPES.OUTGOING && !!leg.value
);
const isFree = computed(() => leg.value === 'astracall');
</script>

<template>
  <span
    v-if="show"
    class="i-lucide-circle-dollar-sign size-3 shrink-0 cursor-help"
    :class="isFree ? 'text-n-teal-10' : 'text-n-amber-10'"
    :title="
      isFree
        ? 'Enviada pela conexão não-oficial — sem custo'
        : 'Enviada pela API oficial do WhatsApp — com custo'
    "
  />
</template>
